import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Changed from 'smooth' to 'instant' to prevent delayed scrolling
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;